const parseMaybeObject = (value) => {
  if (!value) return null;
  if (typeof value === "object") return value;
  if (typeof value !== "string") return null;
  try {
    const parsed = JSON.parse(value);
    return parsed && typeof parsed === "object" ? parsed : null;
  } catch {
    return null;
  }
};

const firstProductArray = (...values) =>
  values.find((value) => Array.isArray(value) && value.length > 0) || null;

/**
 * Prefer the immutable document snapshot over the live project cart.
 * This keeps an Estimate/Sales Order conversion faithful to the document
 * the user is currently viewing, while still supporting older records that
 * predate snapshots.
 */
export const resolvePromoStoreDocumentProducts = (document = {}, fallbackProducts = []) => {
  const stamped = parseMaybeObject(document?.stampedBookedAmount) || {};
  const directSnapshot = parseMaybeObject(document?.cartSnapshot) || {};
  const stampedSnapshot = parseMaybeObject(stamped?.cartSnapshot) || {};
  const directPayload = parseMaybeObject(directSnapshot?.payload) || {};
  const stampedPayload = parseMaybeObject(stampedSnapshot?.payload) || {};

  return firstProductArray(
    document?.products,
    document?.Products,
    directPayload?.Products,
    directPayload?.products,
    directSnapshot?.Products,
    directSnapshot?.products,
    stampedPayload?.Products,
    stampedPayload?.products,
    stampedSnapshot?.Products,
    stampedSnapshot?.products,
  ) || (Array.isArray(fallbackProducts) ? fallbackProducts : []);
};

export const resolveLatestPresentation = (presentationData = []) =>
  [...(Array.isArray(presentationData) ? presentationData : [])]
    .sort(
      (a, b) =>
        new Date(b?.presentationDate || b?.updatedAt || b?.createdAt || 0) -
        new Date(a?.presentationDate || a?.updatedAt || a?.createdAt || 0),
    )[0] || null;
